import React from "react";
import { Link } from "react-router-dom";
import {
  formatCurrencyValue,
  formatDate,
  decimalFormat,
} from "../../../../utils";
import LoadingContainer from "../../../../_components/LoadingContainer";
import ScrollBox from "../../../../_components/ScrollBox";
import Text from "../../../../_components/Text";
import Select from "../../../../_components/Select";
import TableData from "../../../../_components/TableData";

import { filterSales } from "../../../../api/sales";

import DownloadReport from "../../../Fiscal/NFe/List/DownloadReport";

import Page from "../../../../_components/Layout/Page";
import Row from "../../../../_components/Layout/Row";
import Column from "../../../../_components/Layout/Column";

import CardValue from "../../../../_components/CardValue";

import Filter from "../Filter";

const SALE_STATUS = {
  2: <div className="badge badge-primary">Autorizada</div>,
  3: <div className="badge badge-dark">Cancelada</div>,
};
const INVOICE_TYPE = {
  "": "Gerencial",
  1: "NF-e",
  2: "NFC-e",
  3: "Manual",
};
export default (props) => {
  const ref = React.useRef(null);
  const [params, setParams] = React.useState({ end_count: 2 });
  const [loading, setLoading] = React.useState(false);
  const [sales, setSales] = React.useState([]);
  const [reporting, setReporting] = React.useState({
    totalAmount: 0,
    medianTiket: 0,
  });

  function ProccessSalesResult(sales) {
    sales = sales.map((sale, idx) => {
      return {
        ...sale,
        status: SALE_STATUS[sale.status],
        _status: sale.status,
        invoice_type: sale.number ? INVOICE_TYPE[sale.invoice_type] : "Gerencial",
        createdDate: formatDate(sale.created_date),
        totalItems: formatCurrencyValue(sale.total_amount),
        totalAmount: formatCurrencyValue(
          sale.total_amount - sale.discount_value
        ),
        discountValue: formatCurrencyValue(sale.discount_value),
        client: sale.client_nam,
        salesperson: sale.username,
        view: (
          <Link to={`/sale/${sale.id}`}>
            <i className="fas fa-eye"></i>
          </Link>
        ),
      };
    });
    setSales(sales);

    let totalAmount = sales.reduce((acc, next) => {
      return acc + (next.total_amount - next.discount_value);
    }, 0);

    const salesLength = sales.filter((sale) => sale._status === 2).length;

    let medianTiket =
      salesLength > 0 ? decimalFormat(totalAmount / salesLength) : 0;
    medianTiket = formatCurrencyValue(medianTiket);

    totalAmount = formatCurrencyValue(totalAmount);
    setReporting({ totalAmount, medianTiket });
  }

  function search(start_date) {
    setReporting({ totalAmount: 0, medianTiket: 0 })
    if (!start_date) {
      const date = new Date();
      start_date = `${date.getFullYear()}-${date.getMonth() + 1
        }-${date.getDate()}`;
    }
    setParams(prev => ({ ...prev, end_count: 10, start_date }))
    setLoading(true);
    const reqParams = { ...params, end_count: 10, start_date }
    setTimeout(() => {
      filterSales(reqParams)
        .then((sales) => {
          ProccessSalesResult(sales);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }, 1000);
  }

  function subDates(e) {
    let timeToday = new Date(new Date().getTime());
    if (e.value === "yesterday") {
      timeToday.setDate(timeToday.getDate() - 1);
    } else if (e.value === "last_week") {
      timeToday.setDate(timeToday.getDate() - 7);
    } else if (e.value === "last_month") {
      timeToday.setMonth(timeToday.getMonth() - 1);
    }
    search(
      `${timeToday.getFullYear()}-${timeToday.getMonth() + 1
      }-${timeToday.getDate()}`
    );
  }

  function setResult(data) {
    setLoading(true);
    ProccessSalesResult(data);
    setLoading(false);
  }

  React.useEffect(search, [ref.current]);

  return (
    <Page ref={ref}>
      <Row className="pb-4">
        <Column md="4" lg="4">
          <Text color="primary" fontSize="1.3em">
            Clique no botão abaixo para exibir mais filtros
          </Text>
          <Filter
            setResult={setResult}
            bindData={data => setParams(prev => ({ ...prev, ...data }))}
          />
        </Column>
        <Column md="4" lg="4">
          <Text align="center" color="primary" fontSize="1.3em">
            Selecione abaixo um período para visualizar as vendas
          </Text>
          <Select
            disabled={loading}
            onChange={subDates}
            options={[
              {
                label: "Hoje",
                value: "today",
              },
              {
                label: "Ontem",
                value: "yesterday",
              },
              {
                label: "Semana passada",
                value: "last_week",
              },
              {
                label: "Mês passado",
                value: "last_month",
              },
            ]}
          />
        </Column>
      </Row>
      <Row>
        <Column lg="4" xs="12" md="4">
          <CardValue title="Total de Vendas" amountValue={sales.length} />
        </Column>
        <Column lg="4" xs="12" md="4">
          <CardValue
            title="Total Vendido"
            amountValue={reporting.totalAmount}
          />
        </Column>
        <Column lg="4" xs="12" md="4">
          <CardValue title="Ticket Médio" amountValue={reporting.medianTiket} />
        </Column>
      </Row>
      <LoadingContainer loading={loading}>
        <Row>
          <Column col="12">
            <ScrollBox>
              <TableData
                tHead={[
                  "Cód.",
                  "Situação",
                  "Data da Venda",
                  "Modelo",
                  "N° da Nota",
                  "Valor da Nota",
                  "Desconto",
                  "Cliente",
                  "Vendedor",
                  "Total da Venda",
                  "Ações",
                ]}
                tBodyKeys={[
                  "code",
                  "status",
                  "createdDate",
                  "invoice_type",
                  "number",
                  "totalItems",
                  "discountValue",
                  "client_name",
                  "salesperson",
                  "totalAmount",
                  "view",
                ]}
                data={sales}
              />
            </ScrollBox>
          </Column>
        </Row>
        <Row>
          <Column col="12">
            <DownloadReport params={params} />
          </Column>
        </Row>
      </LoadingContainer>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Sales/Report/index.jsx